import React from "react";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles({
  otroIcono: {
    cursor: "pointer",
    borderRadius: "50%",
    padding: "0.5rem",
    "&:hover": {
      backgroundColor: "#00abfb26",
    },
  },
});

export const IconInfo = (props) => {
  const classes = useStyles();
  return (
    <svg
      onClick={() => {
        props.onClick();
      }}
      xmlns="http://www.w3.org/2000/svg"
      className={classes.otroIcono}
      width="48"
      height="48"
      viewBox="0 0 24 24"
      strokeWidth="1.5"
      stroke="#FF5733" // Cambia el color de trazo para el nuevo icono
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <circle cx="12" cy="12" r="9" />
      <line x1="12" y1="8" x2="12" y2="12" />
      <line x1="12" y1="16" x2="12" y2="16" />
    </svg>
  );
};
